export const formatReportDate = (value?: string | null): string => {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';

    const datePart = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    }).format(date);
    const timePart = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    }).format(date);
    return `${datePart} - ${timePart}`;
};

export const formatNumberWithUnit = (
    value: number | null | undefined,
    unit: string,
    fractionDigits = 0,
): string => {
    const numeric = Number(value);
    if (value == null || !Number.isFinite(numeric)) return '—';
    return `${numeric.toFixed(fractionDigits)} ${unit}`;
};
